import { isSubmitInProgress } from './formSubmitGuard';

export { isSubmitInProgress };

/** Lock síncrono — evita carrera entre doble click antes de setState. */
export function isMdMutationLocked(component) {
  return component._mdMutationLock === true || isSubmitInProgress(component.state.loading);
}

/**
 * Ejecuta una acción mutante MD* con guard, loading y reset garantizado.
 */
export async function runMdMutation(component, mutationFn) {
  if (isMdMutationLocked(component)) {
    return;
  }
  component._mdMutationLock = true;
  component.setState({ loading: true });
  try {
    await mutationFn();
  } finally {
    component._mdMutationLock = false;
    component.setState({ loading: false });
  }
}
